import React from 'react';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import ProjectTableRow from './ProjectTableRow';

const ProjectTable = ({ projects, sortConfig, onSort }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center justify-end">
                <span>اسم المشروع</span>
                <button
                  onClick={() => onSort('projectName')}
                  className="ml-2 focus:outline-none"
                >
                  {sortConfig.key === 'projectName' && (
                    sortConfig.direction === 'asc' ? <ArrowUpward className="h-4 w-4" /> : <ArrowDownward className="h-4 w-4" />
                  )}
                </button>
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center justify-end">
                <span>الموقع</span>
                <button
                  onClick={() => onSort('projectPlace')}
                  className="ml-2 focus:outline-none"
                >
                  {sortConfig.key === 'projectPlace' && (
                    sortConfig.direction === 'asc' ? <ArrowUpward className="h-4 w-4" /> : <ArrowDownward className="h-4 w-4" />
                  )}
                </button>
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center justify-end">
                <span>القيمة</span>
                <button
                  onClick={() => onSort('projectValue')}
                  className="ml-2 focus:outline-none"
                >
                  {sortConfig.key === 'projectValue' && (
                    sortConfig.direction === 'asc' ? <ArrowUpward className="h-4 w-4" /> : <ArrowDownward className="h-4 w-4" />
                  )}
                </button>
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center justify-end">
                <span>العميل</span>
                <button
                  onClick={() => onSort('customer')}
                  className="ml-2 focus:outline-none"
                >
                  {sortConfig.key === 'customer' && (
                    sortConfig.direction === 'asc' ? <ArrowUpward className="h-4 w-4" /> : <ArrowDownward className="h-4 w-4" />
                  )}
                </button>
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center justify-end">
                <span>المستشار</span>
                <button
                  onClick={() => onSort('consultant')}
                  className="ml-2 focus:outline-none"
                >
                  {sortConfig.key === 'consultant' && (
                    sortConfig.direction === 'asc' ? <ArrowUpward className="h-4 w-4" /> : <ArrowDownward className="h-4 w-4" />
                  )}
                </button>
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center justify-end">
                <span>التاريخ</span>
                <button
                  onClick={() => onSort('orderDate')}
                  className="ml-2 focus:outline-none"
                >
                  {sortConfig.key === 'orderDate' && (
                    sortConfig.direction === 'asc' ? <ArrowUpward className="h-4 w-4" /> : <ArrowDownward className="h-4 w-4" />
                  )}
                </button>
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              الإجراءات
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {projects.map((project) => (
            <ProjectTableRow key={project.id} project={project} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectTable; 